/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { IntegrationMappingService } from '@xilo-mono/form-contracts';
import { XiloDialogConfig } from '@xilo/library';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'xilo-mono-form-viewer-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss'],
})
export class LoadingModalComponent implements OnInit, OnDestroy {
  progressBar = 0;
  xiloDialogConfig: XiloDialogConfig = {
    header: {
      title: ``,
      showClose: true,
      showBorder: false
    }
  }

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<LoadingModalComponent>,
    private integrationMappingService: IntegrationMappingService,
    @Inject(MAT_DIALOG_DATA) public data: {
      loadSeconds: number,
      headerText:string,
      description:string,
      buttonText:string,
      id: number,
    },
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.data.headerText =  (this.data.headerText !== '' || this.data.headerText === undefined )? 'Processing' : this.data.headerText;
    this.data.description = this.data.description === '' ? 'This may take up to 1 minute while we work our magic to pull the data from the address.' : this.data.description;
    this.data.buttonText =  this.data.buttonText === '' ? 'Cancel' : this.data.buttonText;
    const loadSeconds = this.data.loadSeconds
    this.updateProgressBar(loadSeconds); // Start the progress bar for 5 seconds
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  closeDialog() {
    this.dialogRef.close({ cancelled: true });
  }

  updateProgressBar(durationInSeconds: number) {
    const increment = 100 / (durationInSeconds * 10);
    let progress = 0;
    const progressBarInterval = setInterval(() => {
      progress += increment;
      this.progressBar = progress;
      if (progress >= 100) {
        this.closeDialog();
        clearInterval(progressBarInterval);
      }
    }, 100);
  }
}
